export class XmasTree {
    id: string;
    wellStringId: string;
    oem: string;
    model: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    equipmentBrand: string;
    partNo: string;
    installedDate: string;
    status: string;
    remark: string;
    createdAt: string;
    treecapConn: string;
    treecapConnRemarks: string;
    treeCapConnSize: number;
    treeCapConnThread: string;
    treeCapDescription: string;

    constructor(initialValues: Partial<XmasTree> = {}) {
        Object.assign(this, initialValues);
    }

    reset() {
        const initialValues: Partial<XmasTree> = {
            id: '',
            wellStringId: '',
            oem: '',
            model: '',
            sizeIn: 0,
            ratingPsi: 0,
            manufacturer: '',
            equipmentBrand: '',
            partNo: '',
            installedDate: '',
            status: '',
            remark: '',
            createdAt: '',
            treecapConn: '',
            treecapConnRemarks: '',
            treeCapConnSize: 0,
            treeCapConnThread: '',
            treeCapDescription: '',
        };
        Object.assign(this, initialValues);
    }
}